import { loadScriptInHead } from '../../utils/dom';
import { setGASkimlinksCustomDimension } from '../../utils/analytics';
import {
  PRODUCT_DETAIL_PAGE_TYPE,
  PRODUCT_LIST_PAGE_TYPE,
  EDITION_ID_EN_GB,
  EDITION_ID_DE_DE,
  EDITION_ID_FR_FR,
  EDITION_ID_EN_CA,
  EDITION_ID_EN_AU
} from '../../constants';

const getCountryID = (id) => {
  switch(id) {
    case EDITION_ID_EN_GB:
      return '30283X1542341';
    case EDITION_ID_DE_DE:
      return '30283X1549270';
    case EDITION_ID_FR_FR:
      return '30283X1593671';
    case EDITION_ID_EN_CA:
      return '30283X1586375';
    case EDITION_ID_EN_AU:
      return '88665X1660901';
    default:
      //US ID
      return '30283X879131';
  }
};

export default function Skimlinks(edition_data, page_type){
  const { id } = edition_data;

  const skimlinksID = (page_type === PRODUCT_DETAIL_PAGE_TYPE || page_type === PRODUCT_LIST_PAGE_TYPE)
    ? '30283X1570445'
    : getCountryID(id);

  loadScriptInHead('statistics', `https://s.skimresources.com/js/${skimlinksID}.skimlinks.js`);
  loadScriptInHead('statistics', 'https://r.skimresources.com/api/?callback=globalSkimlinksDataCallback');
}

if (typeof window !== 'undefined') {
  window.globalSkimlinksDataCallback = function(data){
    setGASkimlinksCustomDimension(data);
  };
}

